/** The shipping provider associated with the order. */
export enum ShippingProvider {
  USPS = 'usps',
  UPS = 'ups'
}
